<template>
  <section>
    <Divider class="mt-4 mb-4 bg-delta-grey" />
    <FormRow :fieldNameArr="[$t('QBR_COMMODITY'), '']" :col1Required="true">
      <Select
        v-model="qbrCategoryArr"
        :placeholder="$t('QBR_COMMODITY')"
        element-id="qbrCategory"
        multiple
        filterable
        :max-tag-count="3"
        :disabled="!canUpdate"
        slot="a"
      >
        <Option v-for="(item, index) in qbrCategorySourceList" :value="item.code" :key="index">
          {{ item.commodity + " / " + item.category }}
        </Option>
      </Select>
      <Button v-show="canUpdate" type="success" @click="add" slot="b">{{$t('ADD')}}</Button>
    </FormRow>
    <TablePage 
      :tableWidth="windowWidth"
      :columnsList="columnsList" 
      :resultList="qbrCategoryList"
    ></TablePage>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { Translate } from "@/util/common"

export default {
  name: "QBRCategoryMaintain",
  props: {
    qbrCategoryList: {
      type: Array,
      default: () => [],
    },    
    group: {
      type: Object,
      default: () => null,
    },
  },
  created() {
    let vueInstance = this
    vueInstance.$authHttp
      .get(
        "data-control/COMMODITY"
      )
      .then((response) => {
        let index = 1
        response.data._embedded.dataControlResourceList.forEach(qbrCategory => {
          let data = {
            id: index,
            category: '',
            commodity: '',
            code: ''
          }
          qbrCategory.attributes.forEach(attribute => {
            if (attribute.key == "category") {
              data.category = attribute.value
            }
            if (attribute.key == "commodity") {
              data.commodity = attribute.value
            }
            if (attribute.key == "code") {
              data.code = attribute.value
            }
          })
          vueInstance.qbrCategorySourceList.push(data)
          index++
        })
        vueInstance.$vendorHttp
        .get("/group-account/" + vueInstance.group.uuid + "/data-control/QBR_COMMODITY")
        .then((response) => {
          response.data._embedded.dataControlResourceList.forEach((qbrCategory) => {
            buildQbrPlant(vueInstance, qbrCategory)
          })
        })
        .catch(() => {})
      })
      .catch((error) => {
        console.log(error)
      })
  },
  data() {
    return {
      qbrCategorySourceList: [],
      qbrCategoryArr: [],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            let self = this
            return self.canUpdate
              ? h("Icon", {
                  props: {
                    type: "md-trash",
                    size: 28,
                  },
                  class: "text-delta-red",
                  on: {
                    click: () => {
                      self.remove(params.row)
                    },
                  },
                })
              : h("span")
          },
        },
        {
          renderHeader: (h, params) => {
                var text =  this.$t('ITEM_CATEGORY')
                return h('div', {
                    domProps:{
                    innerHTML:  text
                    }
                })
            },
          key: "commodity",
        },
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    created() {

    },
    add() {
      const vueInstance = this
      if (vueInstance.validation() == null) {
        vueInstance.toggleLoading(true)
        vueInstance.qbrCategoryArr.forEach(select => {
          let entity = vueInstance.qbrCategorySourceList.find(obj => obj.code == select)
          vueInstance.qbrCategoryList.push({code: entity.code, commodity: `${entity.commodity}${entity.category}` })
          vueInstance.toggleLoading(false)
          vueInstance.$linkDataControl(
            vueInstance,
            "QBR_COMMODITY",
            entity.code,
            vueInstance.group.code,
            "GROUP_USER"
          )
        })
      }
    },
    validation() {
      let vueInstance = this
      let errorMessage = ""
      if (vueInstance.qbrCategoryArr.length == 0) {
        errorMessage += "請選擇 QBR Category <br>"
      }
      vueInstance.qbrCategoryArr.forEach((code) => {
        vueInstance.qbrCategoryList.forEach(qbrCategory =>{
          if (qbrCategory.code == code) {
            errorMessage += "重複 QBR Category  <br>"
          }
        })  
      })

      if (errorMessage) {
        return AlertInfo(vueInstance, errorMessage).then(() => {})
      }
      return null
    },
    remove(item) {
      const vueInstance = this
      AlertDelete(vueInstance, `QBR類別 ${item.commodity}`)
        .then(() => {
          vueInstance.toggleLoading(true)
          vueInstance.$unlinkDataControl(vueInstance, "QBR_COMMODITY", item.code, vueInstance.group.code, "GROUP_USER")
          vueInstance.qbrCategoryList.splice(item._index, 1)
        })
        .catch(() => {})
    },
  },
  computed: {
    canUpdate() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_CATEGORY_RELATION_AREA_MODIFIABLE")
      )
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function buildQbrPlant(vueInstance, qbrCategory) {
  vueInstance.qbrCategorySourceList.forEach(obj => {
    if (obj.code == qbrCategory.dataValue) {
      vueInstance.qbrCategoryList.push({code: obj.code, commodity: `${obj.commodity} ${obj.category}` })
    }
  })
}
</script>

<style scoped></style>
